import { config } from '../Constants';

export const instructionImages = {
    verbalInstructions: config.url.CDN_URL + '/Verbal/images/gifted_verbal_online comic.jpg',
    nonVerbalInstructionsPreK: config.url.CDN_URL + '/NonVerbal/images/gifted_nonverbal_PreK and K_Online comic.png',
    nonVerbalInstructionsBD: config.url.CDN_URL + '/NonVerbal/images/gifted_nonverbal_Gr1-4_Online comic.jpg',
    nonVerbalInstructionsEG: config.url.CDN_URL + '/NonVerbal/images/gifted_nonverbal_Gr5-12_Online comic.jpg',
    quantInstructionsBD: config.url.CDN_URL + '/Quant/images/gifted_quant_K-Gr4_Online comic.jpg',
    quantInstructionsEG: config.url.CDN_URL + '/Quant/images/gifted_quant_Gr5-12_Online Comic.jpg'
};